module.exports = "/assets/4c43ab2694370ac5ecd82e10dff05f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LT.png
// module id = 1591
// module chunks = 0